//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'

export default {
  components: {
    DialogAddRelation: () => import('./components/DialogAddRelation/index.vue')
  },
  props: {
    tableData: {
      default: () => []
    },
    loading: {
      default: false
    },
    initialForm: {
      default: () => ({})
    }
  },
  data: function () {
    return {
      currentTableData: this.tableData,
      addDialogVisible: false
    }
  },
  watch: {
    tableData: {
      handler (val) {
        this.currentTableData = val
      },
      immediate: true
    }
  },
  methods: {
    handleDel (row) {
      let data = _.extend({gids: row.data.goodsId}, _.pick(this.initialForm, 'dealerId'))
      this.$axios.post('/mtea/store/admin/dealer/relation/del', data).then(res => {
        this.$notify.success({
          title: '系统提示',
          message: '操作成功'
        })
        this.$emit('submit')
      }).finally(() => {

      })
    },
    handleUpdatePrice (row) {
      let data = _.extend({gid: row.data.goodsId, did: this.initialForm.dealerId}, _.pick(row.data, 'costPrice'))
      console.log('data', data)
      this.$axios.post('/mtea/store/admin/dealer/relation/update', data).then(res => {
        this.$notify.success({
          title: '系统提示',
          message: '操作成功'
        })
        row.state.showPopover = false
        this.$emit('submit')
      }).finally(() => {

      })
    },
  }
}
